import { createClient } from '@supabase/supabase-js';
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from './config';
import { cookieStorage } from './cookieStorage';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
        flowType: 'pkce',
        storage: cookieStorage(),
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
});

export type Provider = 'azure' | 'google';

// Back to /auth after the provider; /auth reads where to go next from sessionStorage (same tab), so the
// Supabase redirect allow-list only needs <site>/auth.
export const REDIRECT_TO_PATH_KEY = 'identity.redirectToPath';

export async function signInWith (provider: Provider, redirectToPath: string) {
    sessionStorage.setItem(REDIRECT_TO_PATH_KEY, redirectToPath);
    const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
            redirectTo: `${window.location.origin}/auth`,
            // User.Read: the identity backend reads the Graph profile (displayName, jobTitle, ...) with the provider token.
            scopes: provider === 'azure' ? 'email User.Read' : undefined,
            queryParams: { prompt: 'select_account' }
        }
    });
    if (error) throw error;
}

// Signs out this browser only, like the SuperTokens signOut() did.
export async function signOut () {
    await supabase.auth.signOut({ scope: 'local' });
}
